<template>
  <div class="main-pagination text-center">
    <p
      aria-live="polite"
      class="text-body-xs-regular text-body-s-regular-desktop"
      role="status"
      v-text="results"
    />

    <btn
      v-show="showLoadMoreButton"
      class="main-pagination__load-more"
      :label="$string('collection.load_more')"
      modifiers="primary"
      type="button"
      @click="handleLoadMore"
    />
  </div>
</template>

<script>

/**
 * Vue: Main pagination (main-pagination)
 * -----------------------------------------------------------------------------
 * Pagination for main-collection and main-search.
 *
 * @param {Object} pagination - Pagination object (from Liquid or Vue).
 * @param {String} results - Number of results string.
 *
 * @emits loadMore - Emit request to load more items.
 *
 */

import Btn from '~global/btn/btn'

export default {
  name: 'MainPagination',

  components: {
    Btn,
  },

  props: {
    pagination: {
      type: Object,
      default: () => ({
        hasNextPage: false,
      }),
    },
    results: {
      type: String,
      default: '',
    },
  },

  emits: { 'load-more': (payload) => typeof payload === 'boolean' },

  computed: {

    /**
     * Compute if the load more button should be visible.
     * @returns {Boolean}
     */
    showLoadMoreButton() {
      return this.pagination.hasNextPage
    },
  },

  methods: {

    /**
     * Handle load more button press.
     */
    handleLoadMore() {
      this.$emit('load-more', true)
    },
  },
}
</script>

<style lang="scss">
@import './main-pagination';
</style>
